import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import useApiData from "../../../hooks/useApiData";

interface Providence {
  id: number;
  providenceName: string;
}

interface ProvidenceFilterProps {
  value: number[];
  onChange: (providenceIds: number[]) => void;
}

// IDs das providências-atividade (conforme ProvidencesUtils.activitiesProvidences())
const ACTIVITIES_PROVIDENCE_IDS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

export default function ProvidenceFilter({
  value,
  onChange,
}: ProvidenceFilterProps) {
  const { apiData } = useApiData();
  const providences = apiData?.providences || [];

  // Filtrar apenas providências-atividade
  const activityProvidences = providences.filter((providence: Providence) =>
    ACTIVITIES_PROVIDENCE_IDS.includes(providence.id)
  );

  // Converter IDs selecionados para objetos de providência
  const selectedProvidences = activityProvidences.filter((providence: Providence) =>
    value.includes(providence.id)
  );

  const handleChange = (_event: any, newValue: Providence[]) => {
    const providenceIds = newValue.map((providence) => providence.id);
    onChange(providenceIds);
  };

  return (
    <Autocomplete
      multiple
      options={activityProvidences}
      value={selectedProvidences}
      onChange={handleChange}
      getOptionLabel={(option: Providence) => option.providenceName || ""}
      isOptionEqualToValue={(option: Providence, value: Providence) =>
        option.id === value.id
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Providências"
          placeholder="Selecione as providências"
        />
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            label={option.providenceName}
            {...getTagProps({ index })}
            key={option.id}
          />
        ))
      }
    />
  );
}

